<template>
    <div>
        <gofix-card title="General Settings">
            <template slot="gofixCard:right_header">
                <span class="editBox position-static cursor-pointer" @click="modalEdit('general')">
                    <img src="img/iconPencil.png" alt  width="18" height="18"/>
                </span>
            </template>
            <b-row>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-215" label="Pre-fill FM Officer In charge with Case creator" oneline>
                        {{ setting.prefill_fm_officer_in_charge_case_creator ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-215" label="Require user to select the last node of Service Category" oneline>
                        {{ setting.require_user_to_select_the_last_node_of_service_category ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-215" label="Detect existing cases of the same property" oneline>
                        {{ setting.detect_existing_cases_of_the_same_property ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-215" label="Hot Button Tracking Frequency" oneline>
                        {{ setting.hot_button_tracking_frequency ? setting.hot_button_tracking_frequency : "" }}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
                <b-form class="pb-20">
                    <b-form-checkbox v-model="modal.data.prefill_fm_officer_in_charge_case_creator" class="ml-3 mb-26"><span class="ml-21">Pre-fill FM Officer In charge with Case creator</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.require_user_to_select_the_last_node_of_service_category" class="ml-3 mb-26"><span class="ml-21">Require user to select the last node of Service Category</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.detect_existing_cases_of_the_same_property" class="ml-3 mb-26"><span class="ml-21">Detect existing cases of the same property</span></b-form-checkbox>
                    <gofix-form-dropdown
                        label="Hot Button Tracking Frequency"
                        append-to-body
                        v-model="modal.data.hot_button_tracking_frequency"
                        :options='["1D","1W","1M"]'
                    >
                    </gofix-form-dropdown>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="save" :loading="modal.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </gofix-card>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    const accounting = require('accounting');
    export default {
        name: 'general-settings',
        components: {},
        data () {
            return {
                setting: {
                    prefill_fm_officer_in_charge_case_creator:false,
                    require_user_to_select_the_last_node_of_service_category: false,
                    detect_existing_cases_of_the_same_property: false,
                    hot_button_tracking_frequency: '',
                },
                modal:{
                    open: false,
                    loading: false,
                    timer: null,
                    title:"Edit General Case Settings",
                    data:{
                        prefill_fm_officer_in_charge_case_creator:false,
                        require_user_to_select_the_last_node_of_service_category: false,
                        detect_existing_cases_of_the_same_property: false,
                        hot_button_tracking_frequency: '',
                    },
                },
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val) {
                if(val && val.case_hot_button_settings) {
                    this.setting = Object.assign(this.setting, {
                        prefill_fm_officer_in_charge_case_creator:false,
                        require_user_to_select_the_last_node_of_service_category: false,
                        detect_existing_cases_of_the_same_property: false,
                        hot_button_tracking_frequency: '',
                    }, val.case_hot_button_settings);
                } else {
                    this.setting = {
                        prefill_fm_officer_in_charge_case_creator:false,
                        require_user_to_select_the_last_node_of_service_category: false,
                        detect_existing_cases_of_the_same_property: false,
                        hot_button_tracking_frequency: '',
                    }
                }
            }
        },
        created() {
            if(this.ClientContractID && this.ClientContractID.case_hot_button_settings) {
                this.setting = Object.assign(this.setting, this.ClientContractID.case_hot_button_settings);
            }
        },
        methods:{
            modalEdit(type) {
                this.modal.data = Object.assign(this.modal.data, this.setting);
                this.modal.loading = false;
                if(type == "general") 
                    this.modal.open = true;
            },
            save(){
                if (this.modal.timer) {
                    clearTimeout(this.modal.timer);
                    this.modal.timer = null;
                }
                this.modal.timer = setTimeout(async () => {
                    this.modal.loading = true;
                    let objClone = {
                        contract_id: this.ClientContractID.id,
                        client_id: this.ClientContractID.client_id,
                        supplier_id: this.ClientContractID.supplier_id,
                        contract_name: this.ClientContractID.contract_name,
                        abbreviation: this.ClientContractID.abbreviation,
                        description: this.ClientContractID.description,
                        deposit_amount: this.ClientContractID.deposit_amount,
                        issuing_bank: this.ClientContractID.issuing_bank,
                        deposit_expiry: this.ClientContractID.deposit_expiry,
                        insurance_expiry: this.ClientContractID.insurance_expiry,
                        insurance_excess: this.ClientContractID.insurance_excess,
                        insurance_type: this.ClientContractID.insurance_type,
                        timezone: this.ClientContractID.timezone,
                        settings: this.ClientContractID.settings,
                        case_hot_button_settings: this.modal.data
                    }

                    objClone.settings = JSON.stringify(objClone.settings);
                    objClone.case_hot_button_settings = JSON.stringify(objClone.case_hot_button_settings);
                    this.$store.dispatch('ContractController/UpdateClientContract', objClone)
                    .then(response => {
                        this.modal.loading = false;
                        this.modal.open = false;
                        this.setting = Object.assign(this.setting, this.modal.data)
                        this.$store.dispatch('ContractController/getClientContractID', objClone.contract_id);
                        this.$alertNotification(this.$notificationV2('editing', 'client_contract_setting'));
                    })
                    .catch(error => {
                        this.modal.loading = false;
                    });
                }, 200);
            },
        }
    }
</script>
